import {
  AcompanhamentoPuericulturaCardQuery,
  AleitamentoMaterno,
  Antecedente,
  AtendimentoPuericultura,
} from 'graphql/types.generated'
import { metaPath } from 'util/metaPath'

import { MChatRfViewModel } from '../../objetivo/puericultura/mchat-rf/model-mChatRf'
import {
  AvaliacaoDesenvolvimentoModel,
  MedicaoAnteriorPuericulturaModel,
  PuericulturaModel,
} from '../../objetivo/puericultura/model'

export type MedicaoAnteriorAcompanhamentoPuericultura = MedicaoAnteriorPuericulturaModel
export type RegistroMChatAcompanhamentoPuericultura = AcompanhamentoPuericulturaCardQuery['registrosMChat'][0]

export const ACOMPANHAMENTO_CRIANCA_URL_MODAL = '/acompanhamento-crianca'

export interface AcompanhamentoPuericulturaModel
  extends Omit<PuericulturaModel, 'hasPuericultura' | 'prenatal' | 'tipoAleitamento' | 'mChatRf'> {
  ultimoAtendimentoPuericultura: AtendimentoPuericultura
  tipoAleitamentoMaterno: AleitamentoMaterno
  preNatalPartoNascimento?: Antecedente
  vacinacaoEmDia: MedicaoAnteriorAcompanhamentoPuericultura
  registrosMChat: RegistroMChatAcompanhamentoPuericultura[]
  mChatRf: MChatRfViewModel
}

export const acompanhamentoPuericulturaFieldName = metaPath<{
  acompanhamentoPuericultura: AcompanhamentoPuericulturaModel
}>()

export const initialValueAvaliacaoAcompanhamento = (
  avaliacao: AvaliacaoDesenvolvimentoModel[]
): AvaliacaoDesenvolvimentoModel[] =>
  avaliacao
    .map<AvaliacaoDesenvolvimentoModel>((item) => ({ ...item, statusButton: item.status }))
    .sort((a, b) => Number(a.id) - Number(b.id))
